export const isProd = [
  "prod.aureaimaging.com",
  "app.aureaimaging.com",
].includes(location.host);
